<script>
import NavBar from "@/components/NavBar";
import SideBarMembers from "@/components/SideBarMembers";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    SideBarMembers,
    FooterBar
  }
}
</script>

<style scoped src="@/assets/css/inbox.css">
</style>

<template>
  <div >
    <nav-bar />

    <section class="main-content columns is-fullheight">
			
        <div class="column is-2 sidebar-container"  >
          <SideBarMembers />
        </div>

    
        <div class=" column is-10">
          <div class="section">
            <router-view/>
          
          
          </div>
        </div>
      
		</section>

    

    <footer-bar />

  </div>

</template>

